import productStatics from '../../../console/_statics/product.statics.json';

interface EligibleProduct {
  readonly productType: string;
}

interface ProductSelectOption {
  readonly label: string;
  readonly value: string;
}

interface EligibleProductSelection {
  readonly options: ProductSelectOption[];
  readonly defaultValue: string;
  readonly hasNoEligibleProducts: boolean;
}

/**
 * Turns a submission's eligible products into what the product select should
 * show. Nothing is invented: an empty response yields no options and no
 * selection, so a backend failure or a genuine lack of entitlement can never
 * pre-select a product the agency may not hold.
 */
export const resolveEligibleProductSelection = (
  eligibleProducts: readonly EligibleProduct[] | undefined
): EligibleProductSelection => {
  const options = (eligibleProducts ?? []).map((product) => ({
    label: productStatics.ProductTypes[product.productType]?.full,
    value: product.productType,
  }));

  return {
    options,
    // A lone genuinely eligible product is still pre-selected, as before.
    defaultValue: options.length === 1 ? options[0].value : '',
    hasNoEligibleProducts: options.length === 0,
  };
};
